// Override Settings
var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        styleScrollToTop: 'style2',
        filterTreeMobileStyle: 'style3',
        /* Optional */
        loadProductFirst: true
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'saleClass': 'on-sale',
    'addToCart': theme.strings.addToCart || 'Add to cart', //Should be defined in theme.liquid
    'addToCompare': theme.strings.addToCompare || 'Add to compare',
    'chooseOptions': theme.strings.chooseOptions || 'Choose Options',
    'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
    'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
    'vendorHtml': '<div>{{itemVendorLabel}}</div>',
    'priceCompareMinHtml': '<span class="product-card-info__compare-price">{{comparePriceMin}}</span>',

    // Grid Template
    'productGridItemHtml': '<div class="col-6 col-lg-4 mb-2">' +
                                '<div data-product-id="{{itemId}}" class="product-card product-card--bc-sf-filter">' +
                                    '<a href="{{itemUrl}}" class="product-card__link">' +
                                        '<img src="{{itemThumbUrl}}" srcset="{{itemThumbSrcUrl}}" alt="{{itemTitle}}" class="img-fluid product-card__picture__img" />' +
                                    '</a>' +
                                    '<div class="product-card__info product-card-info">' +
                                        '<h3 class="product-card-info__title mb-1" data-mh="mh-product-grid-title">{{itemTitleTruncated}}</h3>' +
                                        '<div class="d-lg-flex align-items-center justify-content-between">' +

                                            (
                                              window.theme.domainsWithoutPrice.indexOf(window.theme.requestHost) === -1
                                              ? '<div class="my-1 my-lg-0"><span class="product-card-info__price">{{itemPrice}}</span>{{itemPriceCompareHtml}}</div>'
                                              : ''
                                            )

                                            + '{{itemReviews}}'+
                                        '</div>' +
                                    '</div>' +
                                    '<div class="product-card__cta">' +
                                      '{{itemCTA}}' +
                                      '<label class="product-card__cta__add-to-compare d-none">' +
                                        '<div class="custom-control custom-checkbox">' +
                                          '<input type="checkbox" class="product-card__compare-checkbox custom-control-input" id="product_compare_btn_{{itemId}}">' +
                                          '<label class="product-card__compare-label custom-control-label" for="product_compare_btn_{{itemId}}">{{addToCompare}}</label>' +
                                        '</div>' +
                                      '</label>' +
                                    '</div>' +
                                '</div>' +
                            '</div>',
    // For List View
    // List Template
    'productListItemHtml': '<div class="col-12">' +
                                '<div data-product-id="{{itemId}}" class="product-card product-card--list-view">' +
                                    '<a href="{{itemUrl}}" class="product-card__link">' +
                                        '<img src="{{itemThumbUrl}}" srcset="{{itemThumbSrcUrl}}" alt="{{itemTitle}}" class="img-fluid product-card__picture__img" />' +
                                    '</a>' +
                                    '<div class="product-card--list-view__details">' +
                                    '<div class="product-card__info product-card-info">' +
                                        '<h3 class="product-card-info__title mb-1" data-mh="mh-product-grid-title">{{itemTitleTruncated}}</h3>' +
                                        '<div class="d-lg-flex align-items-center justify-content-start">' +
                                            '<div class="my-1 my-lg-0 mr-1">' +
                                                (window.theme.domainsWithoutPrice.indexOf(window.theme.requestHost) === -1
                                                  ? '<span class="product-card-info__price">{{itemPrice}}</span>' : '')
                                                + '{{itemPriceCompareHtml}}' +
                                            '</div>' +
                                            '{{itemReviews}}'+
                                        '</div>' +
                                    '</div>' +
                                    '<div class="product-card__cta">' +
                                      '{{itemCTA}}' +
                                      '<label class="product-card__cta__add-to-compare d-none">' +
                                        '<div class="custom-control custom-checkbox">' +
                                          '<input type="checkbox" class="product-card__compare-checkbox custom-control-input" id="product_compare_btn_{{itemId}}">' +
                                          '<label class="product-card__compare-label custom-control-label" for="product_compare_btn_{{itemId}}">{{addToCompare}}</label>' +
                                        '</div>' +
                                      '</label>' +
                                    '</div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>',
    // Pagination amount
    'showLimitHtml': '<label class="bc-sf-filter-top-show-limit-label">Show:</label><select class="collection-toolbar collection-toolbar--limits">{{showLimitItems}}</select>',

    // Pagination Template
    'previousActiveHtml': '<span><a class="pagination__bc-" href="{{itemUrl}}">&larr;</a></span>',
    'previousDisabledHtml': '<span class="disabled">&larr;</span>',
    'nextActiveHtml': '<span><a class="pagination__bc-" href="{{itemUrl}}">&rarr;</a></span>',
    'nextDisabledHtml': '<span class="disabled">&rarr;</span>',
    'pageItemHtml': '<span><a class="pagination__bc-" href="{{itemUrl}}">{{itemTitle}}</a></span>',
    'pageItemSelectedHtml': '<span class="current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
    'paginateHtml': '<div class="pagination">{{previous}}{{pageItems}}{{next}}</div>',

    // Sorting Template
    'sortingHtml': '<label class="bc-sf-filter-top-sorting-label">' + bcSfFilterConfig.label.sorting + '</label><select class="collection-toolbar collection-toolbar--sortby">{{sortingItems}}</select>',
};

/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available; // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Convert images to array
  images = data.images_info;
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  return data;
}

BCSfFilter.prototype.prepareSearchParams = function(params, eventType) {
  if (this.isSearchPage()) {
    params['q'] = this.getSearchTerm();
    params['enable_plus_character_search'] = true;
    if (this.searchTermKey != 'q') delete params[this.searchTermKey];
    var enableFuzzy = this.getSettingValue('search.enableFuzzy');
    if (enableFuzzy !== true ) params.fuzzy = enableFuzzy;
    if (this.getSettingValue('search.reduceMinMatch') !== false) {
      params.reduce_min_match = this.getSettingValue('search.reduceMinMatch');
    }
    if (this.getSettingValue('search.fullMinMatch')) params.full_min_match = true;
    if (this.getSettingValue('general.sortingAvailableFirst')) params.sort_first = 'available';
  }
  return params;
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], "200x200") : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    var item2xImage = images.length > 0 ? this.optimizeImage(images[0]['src'], "200x200@2x") : bcSfFilterConfig.general.no_image_url;
    var itemThumbSrcUrl = itemThumbUrl + ' 1x, ' + item2xImage + ' 2x';
    itemHtml = itemHtml.replace(/{{itemThumbSrcUrl}}/g, itemThumbSrcUrl);

    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, this.formatMoney(firstVariant.price));

    // Add Form Button
    itemHtml = itemHtml.replace(/{{itemCTA}}/g, buildCTA(data));

    itemHtml = itemHtml.replace(/{{addToCart}}/g, bcSfFilterTemplate.addToCart);
    itemHtml = itemHtml.replace(/{{chooseOptions}}/g, bcSfFilterTemplate.chooseOptions);
    itemHtml = itemHtml.replace(/{{addToCompare}}/g, bcSfFilterTemplate.addToCompare);


    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    // Add onSale class
    var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add soldOut Label
    var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // Add onSale Label
    var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Compare Price Min
    var itemPriceCompareHtml = '';
    if (firstVariant.price < firstVariant.compare_at_price) {
        itemPriceCompareHtml = bcSfFilterTemplate.priceCompareMinHtml.replace(/{{comparePriceMin}}/g, this.formatMoney(firstVariant.compare_at_price));;
    }
    itemHtml = itemHtml.replace(/{{itemPriceCompareHtml}}/g, itemPriceCompareHtml);

    // Get Truncated Title if the length is over 35.
    // var itemTitleTruncated = data.title.length > 35 ? data.title.slice(0, 32) + "..." : data.title;
    var itemTitleTruncated = data.title;

    // Build Reviews
    var itemReviewsHtml = '';
    if (window.theme.settings.yotpoReviewsEnabled) {
      itemReviewsHtml = '<div class="grid-view-item__reviews my-1 my-md-0"><div class="yotpo bottomLine product-card-info__yotpo" data-domain="{{itemDomain}}" data-product-id="{{itemId}}"  data-product-models="{{itemId}}" data-name="{{itemTitle}}" data-url="{{itemUrl}}"></div></div>';
    } else {
      itemReviewsHtml = '';
    }
     itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);
    // Build Domain
    itemHtml = itemHtml.replace(/{{itemDomain}}/g, this.escape(bcSfFilterConfig.shop.domain));

    // Build Description
    var itemDescription = data.description;
    itemDescription = itemDescription.substr(0, itemDescription.indexOf('##highlights##'));
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

    // Build Tags
    itemHtml = itemHtml.replace(/{{itemTags}}/g, this.escape(data.tags.join(';')));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemVariantId}}/g, firstVariant.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemTitleTruncated}}/g, itemTitleTruncated);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};


// Build Product Grid Item
BCSfFilter.prototype.buildProductListItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productListItemHtml;

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], "200x200") : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    var item2xImage = images.length > 0 ? this.optimizeImage(images[0]['src'], "200x200@2x") : bcSfFilterConfig.general.no_image_url;
    var itemThumbSrcUrl = itemThumbUrl + ' 1x, ' + item2xImage + ' 2x';
    itemHtml = itemHtml.replace(/{{itemThumbSrcUrl}}/g, itemThumbSrcUrl);

    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, this.formatMoney(firstVariant.price));

    // Add Form Button
    itemHtml = itemHtml.replace(/{{itemCTA}}/g, buildCTA(data));

    itemHtml = itemHtml.replace(/{{addToCart}}/g, bcSfFilterTemplate.addToCart);
    itemHtml = itemHtml.replace(/{{chooseOptions}}/g, bcSfFilterTemplate.chooseOptions);
    itemHtml = itemHtml.replace(/{{addToCompare}}/g, bcSfFilterTemplate.addToCompare);


    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    // Add onSale class
    var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add soldOut Label
    var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // Add onSale Label
    var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Compare Price Min
    var itemPriceCompareHtml = '';
    if (firstVariant.price < firstVariant.compare_at_price) {
        itemPriceCompareHtml = bcSfFilterTemplate.priceCompareMinHtml.replace(/{{comparePriceMin}}/g, this.formatMoney(firstVariant.compare_at_price));;
    }
    itemHtml = itemHtml.replace(/{{itemPriceCompareHtml}}/g, itemPriceCompareHtml);

    // Get Truncated Title if the length is over 35.
    var itemTitleTruncated = data.title.length > 35 ? data.title.slice(0, 32) + "..." : data.title;

    // Build Reviews
    var itemReviewsHtml = '';
    if (window.theme.settings.yotpoReviewsEnabled) {
      itemReviewsHtml = '<div class="grid-view-item__reviews"><div class="yotpo bottomLine product-card-info__yotpo" data-domain="{{itemDomain}}" data-product-id="{{itemId}}"  data-product-models="{{itemId}}" data-name="{{itemTitle}}" data-url="{{itemUrl}}"></div></div>';
    } else {
      itemReviewsHtml = '';
    }
     itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

    // Build Domain
    itemHtml = itemHtml.replace(/{{itemDomain}}/g, this.escape(bcSfFilterConfig.shop.domain));

    // Build Description
    var itemDescription = data.description;
    itemDescription = itemDescription.substr(0, itemDescription.indexOf('##highlights##'));
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemVariantId}}/g, firstVariant.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemTitleTruncated}}/g, itemTitleTruncated);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

/************************** END BUILD PRODUCT LIST **************************/


/************************** BUILD PRODUCT ITEM ELEMENTS **************************/

function buildCTA(data) {
  var html = '';

  if (window.theme.domainsWithoutAtc.indexOf(window.theme.requestHost) > 0) {
    return html;
  }

  if (data.variants.length > 1) {
    html += '<a href="{{itemUrl}}" class="btn btn-primary product-card__cta__add-to-cart">{{chooseOptions}}</a>';
  } else {
    html += '<form method="post" action="/cart/add">' +
              '<input type="hidden" name="id" value="{{itemVariantId}}" />' +
              '<input min="1" type="hidden" id="quantity" name="quantity" value="1" class="d-none" />' +
              '<input class="btn btn-primary product-card__cta__add-to-cart" type="submit" name="add" value="{{addToCart}}" data-add-to-cart />' +
            '</form>';
  }

  return html;
}

/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.bottomPagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.bottomPagination).html(paginationHtml);
        }
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            sortingItemsHtml += '<option value="Sort By" disabled>Sort By</option>';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};


// For Toolbar - Build Display type
// We already defined icons in theme.liquid
BCSfFilter.prototype.buildFilterDisplayType = function() {
    var itemHtml = '';
  // var itemHtml = '<span>' + bcSfFilterConfig.label.toolbar_viewas + '</span>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="collection__view__btn d-flex justify-content-center align-items-center" data-view="grid">{{iconGrid}}</a>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="collection__view__btn d-flex justify-content-center align-items-center" data-view="list">{{iconList}}</a>';

  itemHtml = itemHtml.replace(/{{iconGrid}}/g, theme.resources.iconGrid);
  itemHtml = itemHtml.replace(/{{iconList}}/g, theme.resources.iconList);

  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  topDisplayTypeSelector.html(itemHtml);

  // Active current display type
  topDisplayTypeSelector.find('.collection__view__btn').removeClass('collection__view__active');
  if (this.queryParams.display == 'list') {
    topDisplayTypeSelector.find('[data-view="list"]').addClass('collection__view__active');
    // listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
  } else if (this.queryParams.display == 'grid') {
    topDisplayTypeSelector.find('[data-view="grid"]').addClass('collection__view__active');
    // listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
  }
};
// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function() {
  var _this = this;
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  jQ(this.getSelector('topDisplayType') + ' a').click(function(e) {
    e.preventDefault();
    _this.internalClick = true;
    jQ(this).parent().children().removeClass('active');
    jQ(this).addClass('active');
    if (_this.queryParams.display == 'list') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
    } else if (_this.queryParams.display == 'grid') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
    }
    var newUrl = jQ(this).attr('href');
    _this.onChangeData(newUrl, 'display');
  })
};
// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
  if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ(this.selector.topShowLimit).html('');
    // var numberList = this.getSettingValue('general.showLimitList');
    var maxLimit = 50;
    var limit = parseInt(this.getSettingValue('general.limit')) || maxLimit;

    if (limit != '') {
      // Build content
      var showLimitItemsHtml = '';
      var limitCounts = parseInt(maxLimit / limit);
      for (var k = 1; k <= limitCounts; k++) {
        if (limit * k <= maxLimit) {
          showLimitItemsHtml += '<option value="' + limit * k + '">' + limit * k + '</option>';
        }
      }
      if (limit * limitCounts < maxLimit) {
        showLimitItemsHtml += '<option value="' + maxLimit + '">' + maxLimit + '</option>';
      }

      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      jQ(this.selector.topShowLimit).html(html);

      // Set value
      jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
    }
  }
};


// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  if (typeof Yotpo !== 'undefined') {
    var api = new Yotpo.API(yotpo);
    api.refreshWidgets();
  }
};

BCSfFilter.prototype.buildShowLimitEvent = function() {
    var _this = this;
    jQ('#bc-sf-filter-top-show-limit select').change(function(e) {
        onInteractWithToolbar(e, 'limit', _this.queryParams.limit, jQ(this).val());
    })
};


// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  $('[data-add-to-cart]').on('click', function(event) {
    var $form = $(this).closest('form');
    event.preventDefault();
    $.ajax({
      type:"POST",
      url: "/cart/add.js",
      data: $form.serialize(),
      dataType: 'json',
      success: function() {
        $(document).trigger('panelCartUpdate');
      }, error: function() {
        console.error('Oops! Something went wrong. Please try again...');
      }
    });
  });

  // Make sure jquery match height plugin is included in bc-sf-filter.liquid
  $('[data-mh]').matchHeight();
};


/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
